// Fixed DashboardLayout.tsx - Proper alignment
import React, { useState } from 'react';
import Sidebar from './Sidebar';

interface DashboardLayoutProps {
  children: React.ReactNode;
  currentPage?: string;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
  children, 
  currentPage = 'Dashboard' 
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex">
      {/* Mobile Sidebar Overlay */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* Sidebar - Fixed positioning */}
      <div className="hidden lg:block w-64 flex-shrink-0">
        <Sidebar 
          isOpen={true} 
          onClose={() => setSidebarOpen(false)} 
          currentPage={currentPage}
        />
      </div>

      {/* Mobile Sidebar */}
      {/* <div className={`${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:hidden transition-transform duration-300 fixed z-30 w-64 h-screen`}>
        <Sidebar 
          isOpen={sidebarOpen} 
          onClose={() => setSidebarOpen(false)} 
          currentPage={currentPage}
        />
      </div> */}

      {/* Main Content Area - Flex-1 to take remaining space */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Mobile Menu Button - Only show on mobile */}
        <div className="lg:hidden bg-white/80 backdrop-blur-lg border-b border-white/20 p-4 flex-shrink-0">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors"
          >
            <span className="text-gray-600">☰</span>
          </button>
        </div>

        {/* Page Content - Scrollable */}
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;